import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DomainSettings } from '../models/domain-settings';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class SettingsService extends ServiceBase {
    constructor(private http: HttpClient) {
        super();
    }

    getDomainSetting(): Observable<DomainSettings> {
        return this.http.get<DomainSettings>(`${this.baseUrl}/api/domain/configuration`);
    }
}
